export default {
	USER_ID: "user_AKs5bua1c2cWAiEIowo3R",
	SERVICE_ID: "service_t202yl9",
	TEMPLATE_ID: "template_hgec2p2",
};